import {
  forgetLiveUser,
  liveUserScopeFromLocation,
  rememberedLiveUser,
  rememberLiveUser,
  scopeFromRequestUrl,
  userTokenStorageKey
} from '../../../shared/live-user-session'

function storage () {

  try {

    return window.localStorage
  } catch (err) {

    return null
  }
}

function currentScope (override) {

  const location = typeof window === 'undefined' ? null : window.location

  return liveUserScopeFromLocation(location, override)
}

function readLoggedInUser (override) {

  const scope = currentScope(override)

  return rememberedLiveUser(storage(), scope.account, scope.application)
}

function readUserToken (override) {

  const scope = currentScope(override)
  const key = userTokenStorageKey(scope.account, scope.application)
  const store = storage()

  if (!key || !store) return ''

  return store.getItem(key) || ''
}

function writeLoggedInUser (username, override) {

  const scope = currentScope(override)

  rememberLiveUser(storage(), scope.account, scope.application, username)
}

function clearLoggedInUser (override) {

  const scope = currentScope(override)

  forgetLiveUser(storage(), scope.account, scope.application)
}

function clearLoggedInUserForUrl (url) {

  const origin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin
  const scope = scopeFromRequestUrl(url, origin)

  if (!scope) return

  clearLoggedInUser(scope)
}

export {
  readLoggedInUser,
  readUserToken,
  writeLoggedInUser,
  clearLoggedInUser,
  clearLoggedInUserForUrl
}
